import LoadingProgress from "components/LoadingProgress";
import React, { lazy, Suspense, useMemo } from "react";
import { useParams } from "react-router-dom";

// Map allowed post ids to import functions. Add entries here for each post.
const importerMap = {
  "20251206-LaChuaTrail": () => import("./20251206-LaChuaTrail"),
};

export default function PostContents() {
  const { postId } = useParams();

  const importer = importerMap[postId];
  if (!importer) return <div>Post not found</div>;

  // Memoize the lazy component so it isn't recreated every render
  const LazyPost = useMemo(() => lazy(importer), [postId]);

  return (
    <Suspense fallback={<div>
      <LoadingProgress />
    </div>}>
      <LazyPost />
    </Suspense>
  );
}